import { ILoadContentGuidelinesAction, IState } from '../../../types/state';

export const loadContentGuidelines = (state: IState, action: ILoadContentGuidelinesAction): IState => ({
    ...state,
    contentGuidelines: [...action.contentGuidelines],
    blankTemplates: [...action.defaultContentGuidelines],
    premadeTemplates: [...action.globalContentGuidelines],
    isEditMode: false,
  });
